<div class="table-responsive">
    <table class="table table-bordered">
        <thead>
            <tr>
              <th *ngFor="let header of headers">
                {{ header.label }}
              </th>
            </tr>
          </thead>
        <tbody>
            <tr *ngFor="let item of result">
                <td class="col-4">{{ item?.brandName }}</td>
                <td class="col-3">{{ item?.modelName }}</td>
                <td class="col-4">{{ item?.modelQualifier }}</td>
                <td class="col-1"><input type="checkbox" class="form-check-input" [(ngModel)]="item.selected" (change)="selectPcdbData(item)" /></td>
            </tr>
        </tbody>
    </table>
</div>
